// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu-container {
  position: relative;
}

.user-menu-dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  overflow: hidden;
  z-index: 1000;
}

.menu-item {
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
}

.menu-item svg {
  color: #000;
}

.menu-item:hover:not(.disabled) {
  background: #f5f5f5;
}

.menu-item.disabled {
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.menu-item.disabled svg {
  color: #999;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/UserMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":[".user-menu-container {\n  position: relative;\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: 50px;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 220px;\n  overflow: hidden;\n  z-index: 1000;\n}\n\n.menu-item {\n  width: 100%;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  text-align: left;\n  font-size: 14px;\n  color: #000;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.2s;\n}\n\n.menu-item svg {\n  color: #000;\n}\n\n.menu-item:hover:not(.disabled) {\n  background: #f5f5f5;\n}\n\n.menu-item.disabled {\n  color: #999;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.menu-item.disabled svg {\n  color: #999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
